import React from "react";
import CommonCsvExport from "./CommonCsvExport";

const AuditLogExport = () => {
  return (
    <CommonCsvExport
      pageTitle="監査ログ出力"
      cardTitle="期間指定ダウンロード"
      description={
        <>
          指定した期間の全ユーザーの監査ログをCSV形式で出力します。
          <br />
          カテゴリ、プロジェクト、ユーザーの変更履歴です。
          <br />
          Excelでそのまま開ける形式（UTF-8 BOM付）です。
        </>
      }
      apiPath="/api/audit_log_exports"
      fileNamePrefix="audit_logs"
    />
  );
};

export default AuditLogExport;
